import React, { useEffect, useRef, useState } from "react";
import { Row, Form, Button, Col,Spinner,Alert} from "react-bootstrap";
import ProgressOverlay from "./ProgressOverlay";
import useFakeProgress from "../../Utils/useFakeProgress";
import { LinkService } from "../../Services/LinkService.jsx";
// import { LinkService } from '../Services/LinkService.jsx';


const EnterEmailDialog = ({ link, onContinue, canCreateLinks = true, onUpgradeNeeded = null }) => {

  const [loading, setLoading] = useState(false); // Loader state
  const [showProgress, setShowProgress] = useState(false);
  const progress = useFakeProgress({ totalMs: 45000, cap: 92 });
const [apiResponse, setApiResponse] = useState(null);
  const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
      email: "",
    });
  const createdLinkRef = useRef(null);
  const linkStatusRef = useRef(null);
  const processingErrorRef = useRef(null);
  const statusPollingRef = useRef(null);

  useEffect(() => {
    return () => {
      if (statusPollingRef.current) {
        clearInterval(statusPollingRef.current);
        statusPollingRef.current = null;
      }
    };
  }, []);
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };
  
    // Validate form
  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email address";
    return newErrors;
  };

  const extractLinkFromResponse = (response) => {
    const data = response?.data;
    if (!data) return null;
    if (data.link) return data.link;
    if (data.data) return data.data;
    return data;
  };

  const extractLinkId = (linkData, response) => {
    return linkData?.id || linkData?.linkId || response?.data?.linkId || response?.data?.id;
  };

  const updateStatusState = (statusData) => {
    linkStatusRef.current = statusData?.status || null;
    processingErrorRef.current = statusData?.processingError || null;
    createdLinkRef.current = {
      ...(createdLinkRef.current || {}),
      ...statusData
    };
  };

  const stopStatusPolling = () => {
    if (statusPollingRef.current) {
      clearInterval(statusPollingRef.current);
      statusPollingRef.current = null;
    }
  };

  const pollLinkStatusUntilDone = (linkId) => {
    if (!linkId) return;
    stopStatusPolling();

    const pollOnce = async () => {
      try {
        const statusResponse = await LinkService.fetchLinkStatus(linkId);
        const statusData = statusResponse?.data || {};
        updateStatusState(statusData);

        if (statusData.status === 'completed') {
          stopStatusPolling();
          setApiResponse({
            success: statusData.message || 'Link ready! 🎉 Navigate to the Dashboard to view your link.'
          });
        } else if (statusData.status === 'failed') {
          stopStatusPolling();
          setApiResponse({
            error: statusData.processingError || statusData.message || 'Link processing failed. Please try again.'
          });
        }
      } catch (error) {
        console.error('❌ Error polling link status:', error);
      }
    };

    pollOnce();
    statusPollingRef.current = setInterval(pollOnce, 4000);
  };

  const handleContinueClick = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length === 0) {
      // Check if user can create links before proceeding
      if (!canCreateLinks && onUpgradeNeeded) {
        console.log("User cannot create links, triggering upgrade modal");
        onUpgradeNeeded();
        return;
      }
      
      try {
        setShowProgress(true);
        progress.start();
        setLoading(true); // Start loader
        
        const response = await LinkService.createLink({
          originalUrl: link,
          caption: formData.email,
        });
        const linkData = extractLinkFromResponse(response);
        const linkId = extractLinkId(linkData, response);

        createdLinkRef.current = linkData;
        updateStatusState(linkData || response?.data || {});
        const isProcessing = response?.status === 202 || linkData?.status === 'processing';
        setApiResponse({
          success: response?.data?.message || (
            isProcessing
              ? 'Link accepted and processing. We will update once it is ready.'
              : 'Link created successfully! 🎉 Navigate to the Dashboard to view your link.'
          )
        });
        progress.complete();
        setTimeout(() => setShowProgress(false), 600);
        onContinue();

        if (isProcessing) {
          pollLinkStatusUntilDone(linkId);
        }
        
      } catch (error) {
        console.log('ERROR IS '+error.response?.data?.message);
        setApiResponse({ error: error.response?.data?.message || 'Signup failed' });
      }
      finally {
        if (!apiResponse || apiResponse?.error) {
          setTimeout(() => setShowProgress(false), 300);
          progress.reset();
        }
        setLoading(false); // Stop loader
      }
      
      
    } else {
      setErrors(validationErrors);
    }
  };
return (
    <>
      <ProgressOverlay visible={showProgress} percent={progress.percent} />
      <Row className="justify-content-center" >
        <Col xs={12} md={6}>
          <div className="p-4 border rounded shadow-sm position-relative" >
            <Button
            variant="light"
            className="position-absolute"
  onMouseEnter={(e) => e.target.classList.add('bg-secondary')}
  onMouseLeave={(e) => e.target.classList.remove('bg-secondary')}
            style={{
              top: "10px",
              right: "10px",
              padding: "5px",
            }}
          >
            <img
              src="/assets/btn_close.png"
              style={{
                width: "20px",
                height: "20px",
                objectFit: "cover",
              }}
              alt="Close"
            />
          </Button>
            <div className="d-flex justify-content-between align-items-center">
              <h5>Enter your email to receive your sharable link</h5>
              
            </div>
            <p className="text-muted">
              Your email will be used so that you can view your link's
              performance.
            </p>
            <Form>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email here"
                  name="email"
                    value={formData.email} onChange={handleInputChange} isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>
              <Button
                variant="dark"
                className="rounded-pill px-4"
                onClick={handleContinueClick}
                disabled={loading}
              >
                 {loading ? (
          <>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            {' Please Wait...'}
          </>
        ) : (
          'Continue'
        )}
              </Button>
              {apiResponse && (
        <Alert variant={apiResponse.error ? 'danger' : 'success'} className="mt-3">
          {apiResponse.error || 'Link created successfully! 🎉 Navigate to the Dashboard to view your link.'}
        </Alert>
      )}
            </Form>
          </div>
        </Col>
      </Row>
    </>
);
};

export default EnterEmailDialog;
